/**
 * Helper selector for interactive styles. Since many components support polymorphing
 * to an interactive element, styling those properly shall be handled easily.
 * The decision here is to style only those with an underlying interactive element with help of
 * a css selector. We can add support here if a new element (e.g., a specific role) is needed.
 * It is not automatically selecting elements with tabIndex set, since those usually just add
 * extra keyboard functionality. The useFocusRing hook takes care of the proper focus styling.
 * @internal
 */
export const _InteractiveSelector = 'button&:not(:disabled), a&:not(:disabled)';
